import axios from 'axios';

const api = axios.create({
    baseURL: 'https://app.bruk.digital/api',
})

export default api;